import { render } from "./AddEvent.vue?vue&type=template&id=8d4316d6&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"

import "./AddEvent.vue?vue&type=style&index=0&id=8d4316d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d4316d6"

export default script